module.exports = __webpack_public_path__ + "img/2_D.b118a131.png";